import { MalaPuscicaDol } from 'kzv-icons';
import React from 'react';
import { components } from 'react-select';

function DropdownIndicator(props) {
    return (
        <components.DropdownIndicator {...props}>
            <MalaPuscicaDol style={{ strokeWidth: 1.5 }} />
        </components.DropdownIndicator>
    );
}

export default DropdownIndicator;
